import css from '@styled-system/css';
import styled from 'styled-components';
import { alignSelf, color, compose, space, typography, } from 'styled-system';
import theme from '../theme';
const Link = styled.a `
  ${css({
    fontFamily: 'body',
    fontSize: 0,
    lineHeight: 'normal',
    fontWeight: 'light',
    color: 'brand',
    textDecoration: 'underline',
})}
  ${compose(alignSelf, typography, space, color)}
`;
Link.defaultProps = { theme };
export default Link;
//# sourceMappingURL=Link.js.map